
import React from 'react';
import { FormFieldType } from '@/types/form';
import FieldWrapper from '../FieldWrapper';
import WorksheetSelector from './WorksheetSelector';
import OtherSubjectCheckbox from './OtherSubjectCheckbox';
import { useWorksheetSelection } from './useWorksheetSelection';

interface NextTopicWorksheetSearchFieldProps {
  element: FormFieldType;
}

export const NextTopicWorksheetSearchField: React.FC<NextTopicWorksheetSearchFieldProps> = ({ element }) => {
  const {
    otherSubject,
    setSearchQuery,
    isLoading,
    handleSelectWorksheet,
    handleOtherSubjectChange,
    options,
    selectedOption
  } = useWorksheetSelection({
    element,
    otherSubjectField: 'next_topic_other_subject',
    subjectDataField: 'next_topic_subject_data',
    worksheetIdField: 'next_worksheet_id'
  });

  return (
    <FieldWrapper element={element}>
      <div className="space-y-4">
        <WorksheetSelector
          options={options}
          value={selectedOption}
          onChange={handleSelectWorksheet}
          onInputChange={setSearchQuery}
          isLoading={isLoading}
          disabled={otherSubject}
        />
        
        <OtherSubjectCheckbox
          id="next-topic-other-subject"
          checked={otherSubject}
          onChange={handleOtherSubjectChange}
        />
      </div>
    </FieldWrapper>
  );
};

export default NextTopicWorksheetSearchField;
